const CATEGORY_KEYS = {
    TRANSLATIONS: 'translations',
    PARENT_ID: 'parentId',
    IMAGE: 'img',
    POSITION: 'position',
    ACTIVE: 'active',
    SUBCATEGORIES: 'subcategories',
    CONFIG: 'config',
    HAS_CHANGED: 'hasChanged',
};

export const CATEGORY_CONFIG_KEYS = {
    ICON: 'icon',
    VIEW: 'view',
    MESSAGE: 'message',
    MESSAGE_ACTIVE: 'mesaggeActive',
    EXPANDED: 'expanded',
    HAS_CHANGED: 'hasChanged',
    FILTER_TYPE: 'filterType',
    WITH_SELECT_ALL: 'withSelectAll',
    AVAILABILITY: 'availability',
    ALWAYS_AVAILABLE:'alwaysAvailable',
    SCHEDULE: 'schedule',
    TIME_RANGES: 'timeRanges',
    DAYS: 'days',
    All_DAYS: 'allDayAvailable',
    EVERY_DAY: 'everydayAvailable',
}

export default CATEGORY_KEYS;